// client/src/utils/desktopGoogleSignIn.js
// Helpers for the desktop app's Google sign-in through the system browser
// (GoogleLoginButton + pages/DesktopLogin).

/** The desktop app (1.2.0+) exposes this when it can run Google sign-in in the browser. */
export const desktopGoogleSignIn = () => {
  const api = typeof window !== 'undefined' ? window.electronAPI : undefined;
  return api?.startGoogleSignIn && api?.onGoogleHandoff ? api : null;
};

/** Link that hands the browser's sign-in back to the desktop app. */
export const desktopReturnUrl = (handoff) => `bozarthconnect://auth?handoff=${encodeURIComponent(handoff)}`;
